import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { get } from 'lodash';

interface IInputProps {
  name: string;
  id: string;
  label: string;
  placeholder: string;
  readonly?: boolean;
  disabled?: boolean;
  maxLength?: number;
  defaultValue?: string;
  defaultValueTipo?: string;
  handleOnChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: any;
  req?: any;
  xl?: number;
  md?: number;
  col?: number;
}

const FormInputIPF: React.FC<IInputProps> = ({
  name,
  id,
  label,
  placeholder,
  readonly,
  disabled,
  maxLength,
  req,
  xl = 12,
  md = 12,
  col = 12,
  defaultValue,
  defaultValueTipo
}) => {
  const { register, formState: { errors }, watch, setValue } = useFormContext();
  const tipoRequiredRule = req
    ? (typeof req === 'boolean' ? 'Debe seleccionar un tipo' : req)
    : false;

  useEffect(() => {
    if (defaultValue !== undefined && defaultValue !== null && defaultValue !== "") {
      setValue(name, defaultValue);
    }
    if (defaultValueTipo !== undefined && defaultValueTipo !== null && defaultValueTipo !== "") {
      setValue(name + "Tipo", defaultValueTipo);
    }
  }, []);

  const validateNIE = (value: string) => {
    if (!value) {
      if (!req) return true;
      return typeof req === 'string' ? req : 'Este campo es obligatorio';
    }

    const tipo = watch(name + "Tipo");
    const tipoString = typeof tipo === 'number' ? tipo.toString() : tipo ?? "";

    // Validación para DNI
    if (tipoString === "1") {
      const regexDNI = /^\d{8}[A-Z]$/;
      if (!regexDNI.test(value)) {
        const regexNIE = /^[XYZ][0-9]{7}[A-Z]$/;
        if (regexNIE.test(value)) {
          return "Parece un NIE, selecciona el tipo correcto.";
        }
        return "El DNI debe tener 8 números y una letra mayúscula";
      }

      const dniNumbers = value.substring(0, 8);
      const dniLetter = value.substring(8, 9);
      const letter = calculateDNIletter(dniNumbers);
      if (letter !== dniLetter) {
        return "La letra no coincide";
      }
    }

    // Validación para NIE
    else if (tipoString === "6") {
      const regexNIE = /^[XYZ][0-9]{7}[A-Z]$/;
      if (!regexNIE.test(value)) {
        const regexDNI = /^\d{8}[A-Z]$/;
        if (regexDNI.test(value)) {
          return "Parece un DNI, selecciona el tipo correcto.";
        }
        return "El NIE debe tener 1 letra, 7 números y 1 letra (letras mayúsculas)";
      }

      const initialLetter = value[0];
      if (!["X", "Y", "Z"].includes(initialLetter)) {
        return "La letra inicial del NIE debe ser X, Y o Z";
      }

      const finalLetter = value[8];
      const calculatedLetter = calculateNIEletter(value);
      if (finalLetter !== calculatedLetter) {
        return "La letra final del NIE no coincide";
      }
    }

    // Pasaporte (tipo 2): sin validación de momento
    return true;
  };

  function calculateNIEletter(nie: string): string {
    const nieLetters = "TRWAGMYFPDXBNJZSQVHLCKE";
    const initialLetter = nie[0];
    const numberPart = nie.substring(1, 8);

    let prefixNumber: string;
    switch (initialLetter) {
      case "X":
        prefixNumber = "0";
        break;
      case "Y":
        prefixNumber = "1";
        break;
      case "Z":
        prefixNumber = "2";
        break;
      default:
        return "";
    }

    const fullNumber = prefixNumber + numberPart;
    const index = parseInt(fullNumber, 10) % 23;
    return nieLetters[index];
  }

  function calculateDNIletter(numbers: string): string {
    const dniLetters = "TRWAGMYFPDXBNJZSQVHLCKE";
    const remainder = parseInt(numbers) % 23;
    return dniLetters[remainder];
  }

  const errorMessageInput = get(errors, name)?.message as string | undefined;
  const errorMessageTipo = get(errors, name + "Tipo")?.message as string | undefined;
  const errorMessage = errorMessageInput || errorMessageTipo;

  return (
    <div className={`col-xl-${xl} col-md-${md} col-${col}`}>
      <fieldset className={`input-block input-block--code ${(errors && (errors[name]?.message || errors[name + "Tipo"]?.message)) ? 'error' : ''}`} disabled={disabled}>
        <label htmlFor={id} className="input-block__label m-0">{label}</label>
        <div className="row">
          <div className="col-md-9 col-lg-9">
            <input
              type="text"
              className=''
              name={name}
              id={id}
              placeholder={placeholder}
              {...register(name, {
                required: req,
                validate: validateNIE
              })}
              readOnly={readonly || false}
              disabled={disabled}
              maxLength={maxLength}
            />
          </div>

          <div className="col-md-3 col-lg-3">
            <select
              id={name + "Tipo"}
              {...register(name + "Tipo", {
                required: tipoRequiredRule
              })}
              disabled={disabled}
            >
              <option value=""></option>
              <option value="1">DNI</option>
              <option value="6">NIE</option>
              <option value="2">Pasaporte</option>
            </select>
          </div>

        </div>


        {errorMessage && <p className="error m-0">{errorMessage as any}</p>}
      </fieldset>
    </div>
  );
};

export default FormInputIPF;
